import { JobPostingForEditorWithTabs } from '../../JobPosting'
import { RecommendedJobs } from '../../RecommendedJobs/RecommendedJobs'
import { TailorContentWrapper } from './styles'

type Props = {
  canScrollBottom?: boolean
}

export const TailorContent = (props: Props) => {
  return (
    <TailorContentWrapper>
      <JobPostingForEditorWithTabs {...props}>
        <RecommendedJobs />
      </JobPostingForEditorWithTabs>
    </TailorContentWrapper>
  )
}
